module.exports = __webpack_public_path__ + "static/media/offhirea.3d7335bb.png";